import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { FiPackage } from "react-icons/fi";
import { ProductGroupForm } from "../../../../common/products/ProductGroupForm";

export type ProductGroup = Parameters<typeof ProductGroupForm>[0]["group"];

export const Products = ({ productGroups }: { productGroups: ProductGroup[] | undefined }) => {
  if (!productGroups || productGroups.length === 0) {
    return (
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        width="full"
        border="1px solid"
        borderColor="smBorder"
        rounded="md"
        bg="smBackground"
        py="12"
      >
        <Icon as={FiPackage} boxSize="8" color="smMuted" mb="3" />
        <Text fontSize="md" color="smMuted">
          {t("There are no products in this sourcing event")}
        </Text>
      </Flex>
    );
  }

  return (
    <>
      {productGroups.map((group) => (
        <Box key={group.id} maxWidth="full" pb="5">
          <ProductGroupForm group={group} isDisabled={true} />
        </Box>
      ))}
    </>
  );
};
